import axios from "axios";

const fileCache = new Map<string, Promise<any>>();
const CACHE_MAX = 200;

export const getFile = async (file: string) => {
  const key = file || "";
  let p = fileCache.get(key);
  if (p) return p;
  p = axios.get("/files", { params: { file } });
  fileCache.set(key, p);
  if (fileCache.size > CACHE_MAX) {
    const firstKey = fileCache.keys().next().value;
    if (firstKey !== undefined) fileCache.delete(firstKey);
  }
  return p;
};
